import React from "react";
import "../../assets/css/slides_layouts.comp.css";

// Layout: INTRODUCTION_TITLE_WITH_GOALS
const IntroductionTitleWithGoals = ({title, slideContent}) => {
    let contentArray = [];
    if (Array.isArray(slideContent)) {
        if (slideContent.length === 1 && typeof slideContent[0] === 'string') {
            contentArray = [{PointTitle: "", PointText: slideContent[0]}];
        } else {
            contentArray = slideContent;
        }
    } else if (typeof slideContent === "string") {
        contentArray = [{PointTitle: "", PointText: slideContent}];
    }

    return (
        <div className="slide-container column-layout">
            <h1 className="slide-title">{title}</h1>
            <div className="slide-content-box">
                <ul className="content-list">
                    {contentArray.map((item, index) => (
                        <li key={index} className="list-item">
                            {item.PointTitle &&
                                <strong className="point-title">{item.PointTitle}:</strong>} {item.PointText}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

// Layout: CONTENT_3_POINTS_WITH_NO_IMAGE
const Content3PointsWithNoImage = ({title, slideContent}) => {
    return (
        <div className="slide-container column-layout">
            <h1 className="slide-title">{title}</h1>
            <div className="slide-content-box">
                <ul className="content-list">
                    {slideContent.map((item, index) => (
                        <li key={index} className="list-item">
                            <strong className="point-title">{item.PointTitle}:</strong> {item.PointText}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

// Layout: CONTENT_4_POINTS_WITH_NO_IMAGE
const Content4PointsWithNoImage = ({title, slideContent}) => {
    return (
        <div className="slide-container row-layout">
            <h1 className="slide-title">{title}</h1>
            <div className="slide-content-box">
                <ul className="content-list">
                    {slideContent.map((item, index) => (
                        <li key={index} className="list-item">
                            <strong className="point-title">{item.PointTitle}:</strong> {item.PointText}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

// Layout: CONTENT_2_POINTS_WITH_1_IMAGE
const Content2PointsWith1Image = ({title, slideContent, images}) => {
    return (
        <div className="slide-container row-layout">
            <div className="left-column">
                <h1 className="slide-title">{title}</h1>
                <ul className="content-list">
                    {slideContent.map((item, index) => (
                        <li key={index} className="list-item">
                            <strong className="point-title">{item.PointTitle}:</strong> {item.PointText}
                        </li>
                    ))}
                </ul>
            </div>
            {images.length > 0 && (
                <div className="right-column">
                    <img src={images[0]} alt="Slide" className="slide-image"/>
                </div>
            )}
        </div>
    );
};

// Layout: CONTENT_3_POINTS_WITH_1_IMAGE
const Content3PointsWith1Image = ({title, slideContent, images}) => {
    return (
        <div className="slide-container row-layout">
            {images.length > 0 && (
                <div className="left-column">
                    <img src={images[0]} alt="Slide" className="slide-image"/>
                </div>
            )}
            <div className="right-column">
                <h1 className="slide-title">{title}</h1>
                <ul className="content-list">
                    {slideContent.map((item, index) => (
                        <li key={index} className="list-item">
                            <strong className="point-title">{item.PointTitle}:</strong> {item.PointText}
                        </li>
                    ))}
                </ul>
            </div>

        </div>
    );
};

// Layout: CONTENT_SINGLE_POINT_WITH_1_IMAGE
const ContentSinglePointWith1Image = ({title, slideContent, images}) => {
    let contentItem = {PointTitle: "", PointText: ""};
    if (Array.isArray(slideContent)) {
        if (slideContent.length === 1 && typeof slideContent[0] === "string") {
            contentItem = {PointTitle: "", PointText: slideContent[0]};
        } else if (slideContent.length > 0 && typeof slideContent[0] === "object") {
            contentItem = slideContent[0];
        }
    } else if (typeof slideContent === "string") {
        contentItem = {PointTitle: "", PointText: slideContent};
    }

    return (
        <div className="slide-container row-layout">
            {images.length > 0 && (
                <div className="left-column">
                    <img src={images[0]} alt="Slide" className="slide-image"/>
                </div>
            )}
            <div className="right-column">
                <h1 className="slide-title">{title}</h1>
                <p className="description-text">
                    {contentItem.PointTitle &&
                        <strong className="point-title">{contentItem.PointTitle}: </strong>}
                    {contentItem.PointText}
                </p>
            </div>

        </div>
    );
};

// Layout: CONTENT_DESCRIPTION_WITH_NO_IMAGE
const ContentDescriptionWithNoImage = ({title, slideContent}) => {
    return (
        <div className="slide-container column-layout">
            <h1 className="slide-title">{title}</h1>
            <div className="slide-content-box">
                {slideContent.map((item, index) => (
                <p key={`content-${index}`} className="description-text">{item}</p>
                ))}
            </div>
        </div>
    );
};

// Layout: FINAL_SUMMARY
const FinalSummary = ({title, slideContent}) => {
    return (
        <div className="slide-container row-layout">
            <h1 className="slide-title">{title}</h1>
            <div className="slide-content-box">
                <p className="description-text">{slideContent}</p>
            </div>
        </div>
    );
};


//********** New Layouts ************

// Layout: ContentTitleWithImage
const ContentTitleWithImage = ({ title, images }) => {
    return (
        <div className="slide-container row-layout">
            {/* Left Column - Image */}
                {images.length > 0 && (
                    <div className="left-column">
                        <img src={images[0]} alt="Slide" className="slide-image"/>
                    </div>
                )}

            {/* Right Column - Texts */}
            <div className="right-column">
                <h1 className="slide-title">{title}</h1>
            </div>
        </div>
    );
};

/**
 * LAYOUT:
 *
 * 1. TITLE AND CONTENT WITH ORANGE BACKGROUND:
 *    -  Title
 *    -  Content
 */

const ContentTitleWithDescription = ({ title, slideContent }) => {
    let contentItem = {PointTitle: "", PointText: ""};
    if (Array.isArray(slideContent)) {
        if (slideContent.length === 1 && typeof slideContent[0] === "string") {
            contentItem = {PointTitle: "", PointText: slideContent[0]};
        } else if (slideContent.length > 0 && typeof slideContent[0] === "object") {
            contentItem = slideContent[0];
        }
    } else if (typeof slideContent === "string") {
        contentItem = {PointTitle: "", PointText: slideContent};
    }

    const formattedText = contentItem.PointText.split('\n').map((paragraph, index) => (
        <p key={index} className="content-paragraph">
            {paragraph}
        </p>
    ));

    return (
        <div className="slide-container col-layout">
            <h1 className="slide-title-white">{title}</h1>

            <div className="content-container">
                {formattedText}
            </div>
        </div>
    );
};

/**
 * LAYOUT CASES:
 *
 * 1. NO IMAGE:
 *    - Left column: Title (right-aligned)
 *    - Right column: Content (orange background)
 *
 * 2. WITH IMAGE + TITLE:
 *    - Left column: Image
 *    - Right column: Title + Content (normal styling)
 *
 * 3. WITH IMAGE + NO TITLE:
 *    - Left column: Image
 *    - Right column: Content only (black background, white text)
 */

const ContentWithImageAndList = ({ title, slideContent = [], images = [] }) => {
    const Image = images.length > 0;

    return (
        <div className={`slide-container ${Image ? 'row-layout' : 'no-image-layout'} ${!title ? 'no-title' : ''}`}>
            {/* Left Column (Title when no image) */}
            <div className="left-column">
                {!Image && (
                    <h1 className="slide-title" style={{textAlign:'right', paddingRight:'50px'}}>{title}</h1>
                )}
                {Image && (
                    <img src={images[0]} alt="Slide" className="slide-image"/>
                )}
            </div>

            {/* Right Column (Content) */}
            <div className={`right-column ${!Image ? 'orange-bg' : ''}`}>
                {Image && title && <h1 className="slide-title">{title}</h1>}

                {slideContent.map((item, index) => {
                    if (Array.isArray(item)) {
                        return (
                            <ul key={`list-${index}`} className="content-list" style={{listStyleType: "disc", paddingLeft:'60px'}}>
                                {item.map((point, i) => (
                                    <li key={`point-${i}`} className="list-item">{point}</li>
                                ))}
                            </ul>
                        );
                    }
                    return <p key={`text-${index}`} className="description-text">{item}</p>;
                })}
            </div>
        </div>
    );
};


/**
 * LAYOUT CASE:
 *
 * 1. WITH IMAGE + NO TITLE:
 *    - Right column: Image
 *    - Left column: Content only (black background, white text)
 */


const ContentWithRightImageAndList = ({ title, slideContent = [], images = [] }) => {

    return (
        <div className={`slide-container row-layout ${!title ? 'no-title' : ''}`}>

            {/* Left Column (no title content) */}
            <div className="left-column">
                {slideContent.map((item, index) => {
                    if (Array.isArray(item)) {
                        return (
                            <ul key={`list-${index}`} className="content-list" style={{listStyleType: "disc",color:'#ffffff', paddingLeft:'60px'}}>
                                {item.map((point, i) => (
                                    <li key={`point-${i}`} className="list-item" style={{color:'#ffffff',}}>{point}</li>
                                ))}
                            </ul>
                        );
                    }
                    return <p key={`text-${index}`} className="description-text" style={{color:'#ffffff',}}>{item}</p>;
                })}

            </div>

            {/* Right Column (image) */}
            <div className="right-column">
                    <img src={images[0]} alt="Slide" className="slide-image"/>
            </div>
        </div>
    );
};


/**
 * LAYOUT CASE:
 *
 * 1. WITH IMAGE + NESTED LIST:
 *    - Right column: Image
 *    - Left column: Content only, nested list (black background, white text)
 */

const ContentImageWithLists= ({ title, slideContent = [], images = [] }) => {

    return (
        <div className={`slide-container row-layout ${!title ? 'no-title' : ''}`}>

            {/* Left Column (no title content) */}
            <div className="left-column">
                <img src={images[0]} alt="Slide" className="slide-image"/>

            </div>

            {/* Right Column (image) */}
            <div className="right-column">
                {slideContent.map((item, index) => {
                    if (Array.isArray(item)) {
                        return (
                            <ol key={`main-list-${index}`} className="content-list" style={{listStyleType: "decimal",paddingLeft:'40px',color: '#ffffff'}}>
                                {item.map((point, i) => {
                                    if (typeof point === 'string') {
                                        // Check if next item is a sub-list
                                        const subItems = Array.isArray(item[i+1]) ? item[i+1] : null;
                                        return (
                                            <li key={`point-${i}`} className="list-item">
                                                {point}
                                                {subItems && (
                                                    <ul className="content-list" style={{listStyleType: "disc",paddingLeft: '40px'}}>
                                                        {subItems.map((subPoint, j) => (
                                                            <li key={`sub-${j}`}>{subPoint}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </li>
                                        );
                                    }
                                    return null;
                                })}
                            </ol>
                        );
                    }
                    return (
                        <p key={`text-${index}`} className="description-text" style={{color: '#ffffff'}}>
                            {item}
                        </p>
                    );
                })}
            </div>
        </div>
    );
};

/**
 * LAYOUT CASE:
 *
 * Title slide with numbered list
 *
 */

const ContentTitleWithList = ({ title, slideContent }) => {
    return (
        <div className="slide-container column-layout" >
            <h1 className="slide-title" style={{textAlign:'center'}}>{title}</h1>
            <div className="slide-content-box" style={{ textAlign: 'left', alignItems: 'flex-start' }}>
                <ol className="content-list" style={{ listStyleType: "decimal", paddingLeft: '60px' }}>
                    {slideContent.map((item, index) => (
                        <li key={`point-${index}`} className="list-item">{item}</li>
                    ))}
                </ol>
            </div>
        </div>
    );
};

/**
 * LAYOUT CASE:
 *
 *  - Right column: Text (white background, orange text)
 *  - Left column: Text (orange background, white text)
 *
 */

const SplitLayout = ({ slideContent = [] }) => {
    const leftSide = slideContent[0] || {};
    const rightSide = slideContent[1] || {};

    return (
        <div className="slide-container row-layout">
            {/* Left Column */}
            <div className="left-column white-bg col-flex-box" >
                <div className="content-wrapper">
                {leftSide.header && <h3 style={{color:'#000',margin:'0px',fontSize:'30px',}}>{leftSide.header}</h3>}
                <h3 className="description-text" style={{margin:'0px',fontSize:'30px',color:'#ED6628'}}>{leftSide.text || ''}</h3>
                </div>
            </div>

            {/* Right Column */}
            <div className="right-column orange-bg col-flex-box" style={{height: '100%', paddingTop:'0px'}}>
                <div className="content-wrapper">
                {rightSide.header && <h2 className="description-text" style={{margin:'0px',paddingTop:'0px',fontSize:'30px',}}>{rightSide.header}</h2>}
                <h2 className="description-text" style={{margin:'0px',fontSize:'30px', fontWeight:'normal'}}>{rightSide.task || ''}</h2>
                </div>
            </div>
        </div>
    );
};

/**
 * LAYOUT CASE:
 *
 *  - Title: (center aligned slide title)
 *  - columns: multiple columns in a row with headings, numbers and can have lists/paragraphs
 *
 */

const MultiColumnLayout = ({ title, slideContent }) => {
    return (
        <div className="slide-container column-layout" style={{justifyContent:'normal'}}>
            {title && <h1 className="slide-title" style={{textAlign:'center'}}>{title}</h1>}

            <div className="columns-wrapper">
                {slideContent.map((column, index) => (
                    <div key={`column-${index}`} className="numbered-column">
                        <div className="column-header">
                            <h2 className="column-heading">{column.number}.</h2>
                            <h2 className="column-heading">{column.heading}</h2>
                        </div>

                        <div className="column-content">
                            {column.content.map((item, itemIndex) => {
                                if (Array.isArray(item)) {
                                    return (
                                        <ul key={`list-${itemIndex}`} className="column-list">
                                            {item.map((point, pointIndex) => (
                                                <li key={`point-${pointIndex}`}>{point}</li>
                                            ))}
                                        </ul>
                                    );
                                }
                                return <p key={`text-${itemIndex}`} className="column-text">{item}</p>;
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

/**
 * LAYOUT CASE:
 *
 *  - Title Slide only
 *
 */


const ContentTitle = ({ title }) => {
    return (
        <div className="slide-container column-layout" style={{justifyContent:'center', margin:'0px'}}>
            <h1 className="slide-title" style={{textAlign:'center'}}>{title}</h1>
        </div>
    );
};




export {
    IntroductionTitleWithGoals,
    Content3PointsWithNoImage,
    Content4PointsWithNoImage,
    Content2PointsWith1Image,
    Content3PointsWith1Image,
    ContentSinglePointWith1Image,
    ContentDescriptionWithNoImage,
    FinalSummary,

    ContentTitleWithImage,
    ContentTitleWithDescription,
    ContentWithImageAndList,
    ContentTitleWithList,
    ContentTitle,
    ContentWithRightImageAndList,
    ContentImageWithLists,
    SplitLayout,
    MultiColumnLayout,
};